import*as s from"./index.scss.js";const o=s;export{o as NumberInputTheme};
//# sourceMappingURL=index.js.map
